import { render, staticRenderFns } from "./BaseVideoBunnyPlayer.vue?vue&type=template&id=4c489d78&scoped=true&"
import script from "./BaseVideoBunnyPlayer.vue?vue&type=script&lang=js&"
export * from "./BaseVideoBunnyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideoBunnyPlayer.vue?vue&type=style&index=0&id=4c489d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c489d78",
  null
  
)

export default component.exports